import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { pageview as gaPageview } from '../../services/ga'
import { stateChange as hjStateChange } from '../../services/hotjar'

export default function(WrappedComponent) {
  return class extends Component {
    static propTypes = {
      location: PropTypes.shape({
        pathname: PropTypes.string,
        search: PropTypes.string,
      }),
    }

    UNSAFE_componentWillMount() {
      const { pathname, search } = this.props.location
      const path = `${pathname}${search}`
      gaPageview(path)
      hjStateChange(path)
    }

    render() {
      return <WrappedComponent {...this.props} />
    }
  }
}



// WEBPACK FOOTER //
// ./src/containers/HOC/Analytics.js